import React from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

export const Link: React.FC<LinkProps> = ({ children, ...rest }: LinkProps) => {
  return <RouterLink {...rest}>{children}</RouterLink>;
};
